import { Link } from 'react-router-dom';
import type { FooterSection } from '../types';

interface FooterLinkSectionProps {
  section: FooterSection;
}

const FooterLinkSection = ({ section }: FooterLinkSectionProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-base font-semibold text-white/90">{section.title}</h3>
      <ul className="space-y-3">
        {section.links.map((link) => (
          <li key={link.path}>
            <Link
              to={link.path}
              className="text-white/45 hover:text-accent transition-colors duration-300 text-sm"
            >
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterLinkSection;